<template>
  <div>
    <vx-card class="">
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(createCourse)">
          <div>
            <div class="mb-4 flex items-center w-full">
              <div class="w-1/2 pr-2">
                <label class="col-form-label form-control-label">Course Icon</label>

                <b-form>
                  <base-input class="" :rules="{ required: true }" v-model.lazy="icone" name="Icon">
                    <b-form-file v-model="icone" @change="filesChange" placeholder="Select file"
                      accept=".png,.jpg,.jpeg,.svg"></b-form-file>
                  </base-input>
                  <span v-if="imageErr" class="small text-danger">{{
                    msg.image
                  }}</span>
                </b-form>
              </div>

              <div class="w-1/2 pl-2">
                <label class="col-form-label form-control-label">Course Name</label>

                <base-input v-model="name" name="Name" placeholder="Enter Course Name" class="cust-mb0"
                  :rules="{ required: true, regex: '^[a-zA-Z0-9 ]+$' }"></base-input>
              </div>
            </div>

            <div class="mb-4 flex w-full">
              <div class="w-1/2">
                <!-- <div class="mb-4">
            <b-input
              placeholder="Type a question"
              v-model="text"
              :value="text"
              class="form-control-muted"
            />
          </div> -->
                <div class="">
                  <label class="col-form-label form-control-label">Author Name</label>
                  <div class="flex justify-between">
                    <!-- <select class="form-control mr-4">
                  <option v-for="option in author" :key="option">
                    {{ option.name }}
                  </option>
                </select> -->
                    <!-- <v-select multiple :options="author.name"> -->
                    <!-- <template slot="selection" scope="data">
                  {{ data.item.name }}
                </template> -->
                    <!-- <option v-for="option in author" :key="option">
                  {{ option.name }}

                </option> -->
                    <!-- </v-select> -->
                    <div class="mr-4 w-full">
                      <base-input class="" :rules="{ required: true }" v-model="selectedAuthor" name="Author">
                        <multiselect v-model="selectedAuthor" :options="options" :searchable="false" label="name"
                          track-by="name" :multiple="true" :close-on-select="true" placeholder="Select Author"
                          openDirection="bottom" @input="selectAuth">
                        </multiselect>
                      </base-input>
                    </div>
                    <!-- <div>
                  <base-button
                    size="base"
                    type="primary"
                    @click="DeleteAnswer(index)"
                    >Delete</base-button
                  >
                </div> -->
                  </div>
                </div>
              </div>
              <div class="w-1/2 pl-4">
                <label class="col-form-label form-control-label">Course Categories</label>
                <base-input class="" :rules="{ required: true }" v-model="selectedCat" name="Categories"
                  placeholder="Select Category">
                  <select v-model="selectedCat" class="form-control">
                    <option value="" disabled selected>Select Category</option>
                    <option v-for="option in categories" :key="option._id" :value="option._id">
                      {{ option.name }}
                    </option>
                  </select>
                </base-input>
              </div>
            </div>
            <!-- <div class="mb-4 flex items-center">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Author Name</label
            >
            <base-input placeholder="Enter Author Name"></base-input>
          </div>

          <div class="w-1/2 pl-2 pt-4">
            <p class="font-semibold text-sm mb-2">Course Language</p>
            <base-input class="">
              <select class="form-control ">
                <option> Select </option>
                <option> English </option>

                <option> Hindi </option>
                <option> Marathi </option>
                <option> Tamil </option>
                <option> Spanish </option>
              </select>
            </base-input>
          </div>
        </div> -->
            <!-- 
        <div class="mb-4 ">
          <div class="w-1/2">
            <label class=" col-form-label form-control-label"
              >About the course</label
            >

            <textarea
              class="form-control"
              placeholder="Enter details about the course"
              id="exampleFormControlTextarea3"
              rows="3"
            ></textarea>
          </div>
        </div> -->

            <div class="mb-4 flex w-full">
              <div class="w-full">
                <label class="col-form-label form-control-label">About the course</label>
                <base-input class="" :rules="{ required: true }" v-model="courseFor" name="About">
                  <textarea v-model="courseFor" class="form-control w-full" placeholder="Enter details about the course"
                    id="exampleFormControlTextarea3" rows="3"></textarea>
                </base-input>
              </div>

              <!-- <div class="w-1/2 pl-2">
            <label class="col-form-label form-control-label"
              >Upload Image (About the course)</label
            >

            <b-form>
              <b-form-file
                v-model="aboutImg"
                @change="filesChange"
                placeholder="Select file"
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-form>
          </div> -->
            </div>

            <div class="mb-4 flex w-full">
              <div class="w-1/2 pr-2">
                <label class="col-form-label form-control-label">Course Content</label>

                <!-- <textarea
              v-model="content"
              class="form-control"
              placeholder="Enter Course Content"
              id="exampleFormControlTextarea3"
              rows="3"
            ></textarea> -->
                <!-- <TextEditor /> -->
                <div class="">
                  <base-input class="" :rules="{ required: true }" v-model="content" name="Content">
                    <quill-editor v-model="content" :options="editorOption" class="quill-h300px" />
                  </base-input>
                </div>
              </div>
              <div class="w-1/2 pl-2">
                <div class="mb-4">
                  <label class="col-form-label form-control-label">Total Hours
                  </label>

                  <base-input v-model="duration" placeholder="Enter Total Hours" name="hours" class="mb-0" :rules="{
                    numeric: true,
                    required: true,
                    regex: '^[1-9][0-9]*$',
                  }"></base-input>
                </div>
                <label class="col-form-label form-control-label">Course Description</label>
                <base-input class="" :rules="{ required: true }" v-model="description" name="Description">
                  <textarea v-model="description" class="form-control" placeholder="Enter Who this course is for"
                    id="exampleFormControlTextarea3" rows="3"></textarea>
                </base-input>
              </div>
            </div>
            <!-- <div class="mb-4 flex w-full">
          <div class="w-1/2 pr-2">
            
          </div> -->
            <!-- <div class="w-1/2 pl-2">
            <label class="col-form-label form-control-label"
              >Upload Image (Who this course is for)</label
            >
            <b-form>
              <b-form-file
                v-model="courseForImg"
                @change="filesChange"
                placeholder="Select file"
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-form>
          </div> -->
            <!-- </div> -->
            <div>
              <label class="col-form-label form-control-label">Certificate</label><br />

              <input type="radio" value="false" v-model="appr" id="On Approval" />
              <label for="On Approval" class="mrg-start"> On Approval</label><br />

              <input type="radio" value="true" v-model="appr" id="On complision" />
              <label for="On complision" class="mrg-start">On Completion</label><br />
            </div>
            <div class="w-full flex">
              <div class="w-1/2 pr-2">
                <label class="col-form-label form-control-label">Course Reader Level</label>
                <base-input class="" :rules="{ required: true }" v-model="level" name="Reader Level">
                  <select v-model="level" class="form-control">
                    <option value="" disabled selected>
                      Select Reader Level
                    </option>
                    <option>Beginners</option>
                    <option>Medium</option>
                    <option>High</option>
                  </select>
                </base-input>
              </div>
              <div class="w-1/2 pl-2">
                <label class="col-form-label form-control-label">Course Language</label>
                <base-input class="" :rules="{ required: true }" v-model="language" name="Language">
                  <select v-model="language" class="form-control">
                    <option value="" disabled selected>Select Language</option>
                    <option>Select</option>
                    <option>English</option>

                    <option>Hindi</option>
                    <option>Marathi</option>
                    <option>Tamil</option>
                    <option>Spanish</option>
                  </select>
                </base-input>
              </div>
              <div class="w-1/2 pl-4">
                <label class="col-form-label form-control-label">Course Type</label>

                <base-input class="" :rules="{ required: true }" v-model="courseType" name="Type">
                  <select v-model="courseType" class="form-control">
                    <option value="" disabled selected>
                      Select Course Type
                    </option>
                    <option>Free</option>
                    <option>Paid</option>
                  </select>
                </base-input>
              </div>
            </div>

            <div class="flex items-center">
              <!-- <div class="w-1/2 pr-2 ">
            <label class=" col-form-label form-control-label"
              >Course Categories</label
            >
            <base-input class="">
              <select v-model="selectedCat" class="form-control">
                <option
                  v-for="option in categories"
                  :key="option"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </select>
            </base-input>
          </div> -->

              <!-- <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label"
              >Total Hours
            </label>

            <base-input
              v-model="duration"
              placeholder="Enter Total Hours"
              class="mb-0"
            ></base-input>
          </div> -->
            </div>
            <div class="flex items-center" v-if="courseType === 'Paid'">
              <div class="w-1/2 pr-2">
                <label class="col-form-label form-control-label">Actual Rate (In INR)</label>

                <base-input v-model="price" placeholder="Enter Actual Rate" class="mb-0"
                  :rules="{ numeric: true, regex: '^[1-9][0-9]*$' }" name="price"></base-input>
              </div>
              <div class="w-1/2 pr-2">
                <label class="col-form-label form-control-label">Discount (in %)</label>

                <base-input v-model="discount" placeholder="Enter Discount" class="mb-0"
                  :rules="{ numeric: true, regex: '^[1-9][0-9]*$' }" name="discount"></base-input>
              </div>
              <div class="w-1/2 pr-4">
                <label class="col-form-label form-control-label">Discounted Rate (in INR)</label>

                <base-input v-model="discountPrice" placeholder="Enter Discounted Rate" class="mb-0"
                  readonly></base-input>
              </div>
            </div>
            <div class="flex items-center">
              <div class="w-1/2 pr-2">
                <label class="col-form-label form-control-label">Choose Platform</label>
                <base-input class="" :rules="{ required: true }" v-model="platform" name="Platform">
                  <multiselect v-model="platform" :options="platformOptions" :searchable="false" :multiple="true"
                    :close-on-select="true" placeholder="Select platform" openDirection="bottom"
                    @input="selectPlatform">
                  </multiselect>
                </base-input>
              </div>
            </div>
            <div class="mb-4 pt-4 flex items-center">
              <base-button icon native-type="submit" type="primary" class="">
                <span class="btn-inner--text flex"><feather-icon icon="PlusIcon" class="pr-2"
                    svgClasses="w-4 h-4"></feather-icon>Create Course</span>
              </base-button>
              <!-- <base-button icon type="primary" class="mr-2">
            <span class="btn-inner--text">Publish Course</span>
          </base-button> -->
              <!-- <button @click="resetField">resetField</button> -->
            </div>
          </div>
        </b-form>
      </validation-observer>
    </vx-card>
  </div>
</template>

<script>
import "../../../scss/Index.scss";
import { mapState } from "vuex";
// import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css";
import Multiselect from "vue-multiselect";
import TextEditor from "./TextEditor";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  components: {
    // "v-select": vSelect,
    Multiselect,
    TextEditor,
    quillEditor,
  },
  data() {
    return {
      // categories: "",

      editorOption: {
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "link",
              "blockquote",
              "code-block",
            ],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ font: [] }],
          ],
        },
        placeholder: "Message",
      },

      showPlan: false,
      type: "",
      text: "",
      Answers: ["", ""],
      name: "",
      description: "",
      content: "",
      courseFor: "",
      duration: "",
      price: 0,
      discount: "",
      icone: "",
      courseForImg: "",
      aboutImg: "",
      contentImg: "",
      courseType: "",
      authorNames: [],
      selected: [],
      options: [],
      platformOptions: ["TV", "Mobile", "Desktop", "tabs"],
      language: "",
      selectedCat: "",
      platform: [],
      selectedPlatform: [],
      level: "",
      selectedAuthor: [],
      authorDetails: [],
      appr: false,
      imageErr: false,
      msg: {
        image: "",
      },
    };
  },
  props: {
    toggleCourse: Function,
    shownewpage: {
      type: Boolean,
    },
  },
  watch: {
    text(val) {
      this.$store.commit("posts/SET_POST", { key: "text", value: val });
    },
    Answers(val) {
      this.$store.commit("posts/SET_POST", { key: "Answers", value: val });
    },
    shownewpage(val) {
      if (val === true) {
        this.options = [];
        this.getAuthorDetails();
      }
    },
  },
  methods: {
    filesChange(event) {
      // console.log(this.icone);
      // console.log(data);
      let mByte = 5 * 1048576;
      if (event.target.files[0].size > mByte) {
        this.icone = null;
        event = {};
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        this.imageErr = true;
        this.msg.image = "File size exceeds the allowed limit!";
        // return;
      } else {
        this.imageErr = false;
        if (!event.target.files[0].type.includes("image")) {
          this.icone = null;
          event = {};
          this.imageErr = true;
          this.msg.image = "Upload Image Only";
        } else {
          this.imageErr = false;
          this.icone = event.target.files[0];
        }
      }
    },

    selectAuth(selectedAuthor) {
      // alert(selectedAuthor._id);
      // this.selected.push(selectedAuthor._id);
      this.selected = selectedAuthor;
    },
    // removeAuth(selectedAuthor, id) {
    //   const index = this.selected.findIndex((x) => x == selectedAuthor._id);
    //   this.selected.splice(index, 1);
    // },
    selectPlatform(platform) {
      // this.selectedPlatform.push(platform);
      // console.log(this.selectedPlatform);
      this.selectedPlatform = this.platform;
    },
    handleBack() {
      this.$store.commit("posts/SET_CURRENT_PAGE", "home");
    },
    handleChooseChannel() {
      this.$store.commit("posts/SET_CURRENT_PAGE", "Choose Channel");
    },
    AddNewAnswer(index) {
      if (this.Answers.length - 1 == index) {
        this.Answers.push("");
      }
    },
    DeleteAnswer(index) {
      if ([0, 1].includes(index)) {
        return;
      }
      this.Answers = this.Answers.filter((el, ind) => ind !== index);
    },
    resetField() {
      // console.log("clear");
      // this.$refs.formValidator.reset();
      this.appr = false;
      this.name = "";
      this.description = "";
      this.content = "";
      this.courseFor = "";
      this.duration = "";
      this.courseType = "";
      this.price = "";
      this.discountPrice = "";
      this.icone = "";
      this.discount = "";
      this.courseForImg = "";
      this.aboutImg = "";
      this.contentImg = "";
      this.language = "";
      this.selectedPlatform = [];
      this.platform = [];
      this.authorNames = [];
      this.selected = [];
      this.selectedAuthor = [];
      this.authorDetails = [];
      this.options = [];
      this.selectedCat = "";
      this.level = "";
      // console.log(this.$refs.formValidator);
      // this.$refs["formValidator"].resetValidation();
      // this.$refs["formValidator"].reset();
      this.$nextTick(() => {
        this.$refs.formValidator.reset();
      });

      // this.$validator.reset();
    },
    async createCourse(name = "") {
      let payload = new FormData();

      payload.append("appr", this.appr);
      payload.append("name", this.name);
      payload.append("description", this.description);
      payload.append("content", this.content);
      payload.append("coursefor", this.courseFor);
      payload.append("duration", this.duration);
      payload.append("courseType", this.courseType);
      payload.append("price", this.price);
      payload.append("discountPercent", this.discount);
      if (this.discountPrice == "" || this.discountPrice == 0) {
        payload.append("discountPrice", this.price);
      } else {
        payload.append("discountPrice", this.discountPrice);
      }
      payload.append("icone", this.icone);
      payload.append("courseForImg", this.courseForImg);
      payload.append("aboutImg", this.aboutImg);
      payload.append("contentImg", this.contentImg);
      payload.append("language", this.language);
      this.selectedPlatform.map((data) => {
        payload.append("platform", data);
      });
      payload.append("level", this.level);
      this.selected.map((item) => {
        payload.append("author", item._id);
      });
      payload.append("category", this.selectedCat);
      const loader = this.$loading();
      try {
        const data = await this.$store.dispatch(
          "eLearning/createCourse",
          payload
        );
        if (data.code == 200) {
          this.$swal.fire({
            title: "Created",

            text: "Course has been Created Successfully!",

            icon: "success",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.resetField();
          this.getCategories();

          // console.log(this.selectedCat);
          this.toggleCourse();
          this.showPlan = false;

          loader.close();
        }
      } catch (err) {
        loader.close();
      }
    },

    async getCategories() {
      const { data } = await this.$store.dispatch("eLearning/getCategories");
      this.$store.commit("eLearning/categories", data);
      // console.log(this.platform);
    },
    async getAuthorDetails() {
      const { data } = await this.$store.dispatch("author/getAuthors");
      // console.log(data);
      // console.log(this.authors);
      data[0].result.map((items) => {
        if (items.adminapproval === true) {
          const array = this.options.push({
            name: items.userId[0]
              ? items.userId[0].firstname
                ? items.userId[0].firstname
                : "" + " " + items.userId[0].lastname
                  ? items.userId[0].lastname
                  : ""
              : "",
            _id: items._id,
          });
        }
      });
      // console.log(this.options);
      // console.log(this.selectedAuthor);
    },

    clearFields() {
      this.$nextTick(() => {
        this.mailMessage = "";
      });
    },
    sendMail() {
      this.clearFields();
    },
    getDiscount() {
      if (this.price == "") {
        alert("please enter price first!!");
      } else {
        let discount = (this.price / 100) * this.discount;
        this.discountPrice = this.price - discount;
      }
    },
  },
  mounted() {
    this.getCategories();
    this.getAuthorDetails();
  },
  computed: {
    ...mapState("posts", {
      currentPage: "currentPage",
      type: "type",
    }),
    ...mapState("eLearning", ["categories"]),
    ...mapState("author", ["authors"]),
    title() {
      return this.type.toUpperCase();
    },
    discountPrice() {
      return this.price && this.discount
        ? this.price - (this.price / 100) * this.discount
        : 0;
    },
  },
};
</script>
<style>
.quill-h300px>.ql-container {
  height: 200px;
}

.mrg-start {
  margin-left: 0.5rem !important;
}

.mrg-top {
  margin-top: 0.5rem !important;
}
</style>
